import { render, staticRenderFns } from "./volume-upload-image.vue?vue&type=template&id=f2f646da&scoped=true&"
import script from "./volume-upload-image.vue?vue&type=script&lang=js&"
export * from "./volume-upload-image.vue?vue&type=script&lang=js&"
import style0 from "./volume-upload-image.vue?vue&type=style&index=0&id=f2f646da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f646da",
  null
  
)

export default component.exports